export default __webpack_public_path__ + "static/media/Shower.ea1e199a.png";